import * as React from "react";
import {PluginTemplates} from "@falcon/plugin-falcon-journey";
import {Link} from "react-router-dom";

export class QuoteLimit extends React.Component {

    private pluginTemplates = new PluginTemplates();

    public componentDidMount(): void {
        this.pluginTemplates.setPageTitle("Quote limit");
    }

    public render() {
        return (
            <React.Fragment>
                {this.pluginTemplates.renderHeader()}
                <div className="main-plugin">
                    <p className="panel">You exceeded the number of times the link can be used. Please create a new
                        sales quote</p>
                    <div className="m-5">
                        <Link className="buttonLink" to="/products" id="retrieveQuote">
                            <button type="button" className="btn btn-primary btn-blue-dashboard btn-wide">Continue</button>
                        </Link>
                    </div>
                </div>
                {this.pluginTemplates.renderFooter()}
            </React.Fragment>
        );
    }

}



// WEBPACK FOOTER //
// ./src/pages/quote/QuoteCloneLimitPage.tsx